import {Utils} from "../support/utils";

export class IframeManager {

    constructor(adBuilder) {
        this.adBuilder = adBuilder;
    }

    defaultAttributes() {
        return {
            id: this.adBuilder.container.getAttribute('id') + '_i',
            frameborder: '0',
            style: 'border: 0px;',
            scrolling: 'no',
            vspace: '0',
            hspace: '0',
            marginheight: '0',
            marginwidth: '0',
        };
    }

    getAttributes() {
        let iframeAttributes = this.defaultAttributes();

        switch (this.adBuilder.ad.type) {
            case 'error':
                iframeAttributes.width = '100%';
                iframeAttributes.height = '100%';
                break;
            case 'interstitial':
                iframeAttributes.width = this.adBuilder.context.innerWidth + 'px';
                iframeAttributes.height = this.adBuilder.context.innerHeight + 'px';
                iframeAttributes['data-parentid'] = this.adBuilder.containerId;
                break;
            case 'thumbnail':
                iframeAttributes.width = this.adBuilder.config.width + 'px';
                iframeAttributes.height = this.adBuilder.config.height + 'px';
                break;
            case 'banner':
                iframeAttributes.width = '100%';
                iframeAttributes.height = '50px';
                if (this.adBuilder.ad['adspaceHeight'] != '0') {
                    iframeAttributes.height = this.adBuilder.ad['adspaceHeight'] + 'px';
                }
                break;
            default:
                break;
        }

        if (this.adBuilder.isAdSpace()) {
            iframeAttributes.width = this.adBuilder.ad['adspaceWidth'] + 'px';
            iframeAttributes.height = this.adBuilder.ad['adspaceHeight'] + 'px';
        }

        return iframeAttributes;
    }

    build() {
        let attributes = this.getAttributes();
        this.iframe = document.createElement('iframe');
        Object.entries(attributes).forEach(
            ([key, value]) => this.iframe.setAttribute(key, value)
        );

        return this.iframe;
    }

    initMessagePosting () {
        window.addEventListener("message", this.receiveMessage, false);
    };

    publishCallback(data) {
        this.iframe.contentWindow.postMessage(JSON.stringify({
            "func": "callback",
            "data": data
        }), "*");
    };

    close() {
     //   this.iframe.contentWindow.removeEventListener("message", this.receiveMessage, false);
        this.iframe = null;
    };

    hide() {
        this.iframe.style.display = "none";
        this.publishCallback({
            "event": "hide",
            "result": "true"
        });
    };

    show() {
        this.iframe.style.display = "block";
        this.publishCallback({
            "event": "show",
            "result": "true"
        });
    };

    relayIncomingMessages() {
        const the = this;
        this.iframe.contentWindow.addEventListener('message', function (ev) {
            parent.postMessage({
                message: ev.data,
                iframeId: the.iframe.getAttribute('id'),
                adId: the.adBuilder.containerId
            }, "*")
        }, false);
    }

    addContent(content, handleIncomingMessages = true)
    {
        Utils.iframeAddContent(this.iframe, content);
        if (handleIncomingMessages) {
            this.relayIncomingMessages();
        }
    }

    currentPosition() {
        let rect = this.iframe.getBoundingClientRect();
        this.publishCallback({
            "event": "currentPosition",
            "result": JSON.stringify({
                "left": rect.left,
                "top": rect.top,
                "width": rect.width,
                "height": rect.height
            })
        });
    };
}
